import { IonDatetime } from '@ionic/react';
import classNames from 'classnames';
import { useForCypress } from 'hooks';
import React, { useRef } from 'react';
import s from './TimePicker.module.scss';

function TimePicker({
    placeholder,
    onChange,
    name,
    className,
    disabled,
    value,
    min,
    max
}) {
    const hiddenInput = useRef();

    useForCypress(hiddenInput.current, (value) => {
        onChange(value);
    });

    const timePickerHandle = (e) => {
        onChange(e.detail.value, name);
    };

    return (
        <div className={classNames(s.main, className)}>
            <input
                ref={hiddenInput}
                type="text"
                className={s.hiddenInput}
                id={name}
                name={name}
            />
            <IonDatetime
                className={value && 'value'}
                displayFormat="HH:mm"
                value={value}
                onIonChange={timePickerHandle}
                id="ionicTimePicker"
                mode="ios"
                placeholder={placeholder}
                disabled={disabled}
                min={min ?? min}
                max={max ?? max}
            ></IonDatetime>
        </div>
    );
}

export default TimePicker;
